module.exports = __webpack_public_path__ + "static/media/comments-alt.c4674c61.svg";